




































































import Vue from 'vue'
import VideoPlayIcon from '@/components/VideoPlayIcon.vue'

const ActionMenu = Vue.extend({
  name: 'ActionMenu',
  props: {
    isDetail: {
      type: Boolean,
      required: true
    },
    isOwn: {
      type: Boolean,
      required: true
    },
    isPending: {
      type: Boolean,
      default: false
    },
    onJumpToDetail: {
      type: Function,
      default: () => {}
    },
    onRemove: {
      type: Function,
      default: () => {}
    },
    giftUrl: {
      type: String,
      default: ''
    },
    reportUrl: {
      type: String,
      default: ''
    }
  },
  mounted() {
    window.addEventListener('popstate', this.close, false)
    if (this.$_platformIsAndroid) {
      document.addEventListener('backbutton', this.close, false)
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.close, false)
    if (this.$_platformIsAndroid) {
      document.removeEventListener('backbutton', this.close, false)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  },
  template: `
    <div class="Timeline__menu box list">
      <a class="list__item is-danger" v-if="isOwn && !isPending" @click="onRemove">削除する</a>
      <router-link class="list__item" v-if="!isOwn" :to="giftUrl">ギフトを贈る</router-link>
      <router-link class="list__item" v-if="!isOwn" :to="reportUrl">通報する</router-link>
      <a class="list__item is-danger" @click="close">閉じる</a>
    </div>
  `
})

export default Vue.extend({
  name: 'TimelineMedia',
  components: {
    VideoPlayIcon
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    entryKey: {
      type: Number,
      required: true
    },
    isDetailMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modal: null
    }
  },
  computed: {
    mediaFileClass(): any {
      return {
        'is-16by9 is-object-fit-cover': !this.isDetailMode
      }
    },

    profUrl(): string {
      return '/user/' + this.data.user_id
    },
    chatUrl(): string {
      return '/message/' + this.data.user_id
    },
    giftUrl(): string {
      return this.chatUrl + '/gift'
    },
    reportUrl(): string {
      return `/report/${this.data.user_id}/${encodeURIComponent(
        `/timeline/${this.data.user_id}/${this.data.t_id}`
      )}`
    },
    isPhoto(): boolean {
      return this.data.media_type === 'photo'
    },
    isVideo(): boolean {
      return this.data.media_type === 'video'
    },
    typeLabel(): string {
      if (this.isPhoto) {
        return '写真'
      } else if (this.isVideo) {
        return '動画'
      } else {
        return '投稿'
      }
    }
  },
  destroyed() {
    this.closeActionMenu()
  },
  methods: {
    /**
     * タイムラインの ActionMenu を表示
     */
    showActionMenu(e: Event) {
      this.modal = this.$amatamodal.open({
        parent: this,
        props: {
          isDetail: this.isDetailMode,
          isOwn: this.data.own,
          isPending: this.data.is_pending,
          onRemove: () => {
            this.handleTweetRemove()
          },
          giftUrl: this.giftUrl,
          reportUrl: this.reportUrl
        },
        scrollLock: true,
        hasSideMargin: true,
        component: ActionMenu
      })
    },

    closeActionMenu() {
      if (this.modal) {
        this.modal.close()
        this.modal = null
      }
    },

    jumpToProfile() {
      if (!this.data.own && this.$route.name !== 'user') {
        // 自分のプロフにはアクセスしない
        this.$router.push(this.profUrl)
      }
    },

    jumpToChat() {
      this.$store.commit('Chat/setName', this.data.name)
      this.$store.commit('Chat/setImageUrl', this.data.image_url)
      this.$router.push(this.chatUrl)
    },

    jumpToIine(data: any) {
      if (!data.own || data.is_pending) return

      this.$router.push({
        name: 'timeline/iine',
        params: {
          user_id: this.data.user_id,
          t_id: this.data.t_id
        }
      })
    },

    /**
     * イイねの文字部分をタップ
     */
    handleIineLabelClick(data: any) {
      if (data.own) {
        this.jumpToIine(data)
      } else {
        this.handleIineToggle()
      }
    },

    /**
     * アイコン or 名前をクリック
     */
    handleClickAccount() {
      if (this.data.own) return

      this.$emit('accountClick', this.data, this.entryKey)
    },

    handleIineToggle() {
      this.$emit('iineToggle', this.data, this.entryKey)

      let iineButton = this.$refs.iineButton as HTMLElement
      if (iineButton) {
        // クリックでアニメーションを有効化
        // クリックの時だけアニメーションするようにしないとスクロールだけでアニメーションしてしまう
        if (iineButton.classList.contains('is-iine')) {
          iineButton.classList.remove('is-iine')
        } else {
          iineButton.classList.add('is-iine')
        }
        iineButton = null
      }
    },

    /**
     * Media File をクリック
     */
    async handleMeidaClick(e: Event) {
      if (this.isDetailMode) {
        this.$emit('mediaClick', this.data, this.entryKey)

        // detail を開いている時だけ親のイベントをストップ
        e.stopPropagation()
      }
      // detail じゃなければ親を呼び出すのでここだけは .stop を使わない
    },

    /**
     * ActionMenu 内の削除をクリック
     */
    handleTweetRemove() {
      this.$emit('tweetRemove', this.data.t_id, this.entryKey)
      this.closeActionMenu()
    },

    /**
     * リジェクトされたツイートをクリック
     */
    handleRejectedClick() {
      this.$emit('rejectedClick')
    }
  }
})
